// assets/js/api/authGuard.js

import { authService } from '/assets/js/api/AuthService.js';
import { renderMenu } from '../layouts/menuRenderer.js';

// Funzione che si auto-esegue all'avvio dello script
document.addEventListener('DOMContentLoaded', async () => {
  // Usiamo il pathname completo per una maggiore robustezza
  const currentPath = window.location.pathname;

  // Definiamo le pagine pubbliche in modo più chiaro
  const publicPaths = ['/login', '/resetPsw', '/reset-password', '/conferma-email'];

  // La root '/' è un caso speciale: se l'utente è loggato va bene, se non lo è, va a /login.
  const isPublicPath = publicPaths.some(p => currentPath.startsWith(p));
  const isRootPath = currentPath === '/';

  try {
    const isLoggedIn = await authService.isAuthenticated();

    if (isLoggedIn) {
      // --- UTENTE LOGGATO ---
      renderMenu();
      if (isPublicPath) {
        console.log("Utente loggato su pagina pubblica. Reindirizzamento a /");
        window.location.replace('/');
      }
    } else {
      // --- UTENTE NON LOGGATO ---
      // Se cerca di accedere a una pagina protetta (né pubblica, né la root),
      // lo reindirizziamo alla pagina di login.
      if (!isPublicPath && !isRootPath) {
        console.log("Utente non loggato su pagina protetta. Reindirizzamento a /login");
        // Non è necessario chiamare logout(), perché l'utente non è già autenticato.
        // Un reindirizzamento pulito è sufficiente.
        window.location.replace('/login');
      }
    }
  } catch (error) {
    console.error("Errore durante l'esecuzione dell'Auth Guard:", error);
    // In caso di errore grave (es. API non raggiungibile), reindirizziamo al login per sicurezza.
    if (!isPublicPath && !isRootPath) {
      window.location.replace('/login');
    }
  }
});